module.exports = __webpack_public_path__ + "img/59.280a1fb8.png";